import { render, staticRenderFns } from "./PurchaseInfoLedgersCard.vue?vue&type=template&id=a772f1e4&scoped=true"
import script from "./PurchaseInfoLedgersCard.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfoLedgersCard.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInfoLedgersCard.vue?vue&type=style&index=0&id=a772f1e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a772f1e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a772f1e4')) {
      api.createRecord('a772f1e4', component.options)
    } else {
      api.reload('a772f1e4', component.options)
    }
    module.hot.accept("./PurchaseInfoLedgersCard.vue?vue&type=template&id=a772f1e4&scoped=true", function () {
      api.rerender('a772f1e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseInfoLedgersCard.vue"
export default component.exports